<div class="marker-wrapper" [class.is-for-sale]="data()?.saleStateTypes?.includes(EVNDSaleStateType.Forsale)">
    <div class="icon" [class]="estateTypeCssClass()"></div>
    
    @if (data().saleStateTypes?.includes(EVNDSaleStateType.Withdrawn)) {
        <div class="withdrawn">T</div>
    }

    <div class="price-tag">
        {{ data().projectName }}
    </div>
</div>
